export default "__VITE_ASSET__2cf768d9__"